import { Clasificacion, ClasificacionFiltro } from '../../model/clasificacion/clasificacion';

export abstract class ClasificacionRepository {
  abstract buscar(filtro: ClasificacionFiltro): Promise<Clasificacion[]>;
  abstract contar(filtro: ClasificacionFiltro): Promise<number>;
}
